<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>
        Pencarian
      </h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <b-form-group label="Kanwil" label-for="account-username">
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              v-model="kanwilFilter"
              :options="kanwilOptions"
              :reduce="val => val.value"
              class="w-100"
              multiple
              @input="val => $emit('update:kanwilFilter', val)"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <b-form-group label="Bulan" label-for="account-username">
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              v-model="bulanFilter"
              :options="bulanOptions"
              :reduce="val => val.value"
              @input="val => $emit('update:bulanFilter', val)"
              class="w-100"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <b-form-group label="Tahun" label-for="account-username">
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              v-model="tahunFilter"
              :options="tahunOptions"
              class="w-100"
              :reduce="val => val.value"
              @input="val => $emit('update:tahunFilter', val)"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <b-form-group label="Kategori Tiket" label-for="account-username">
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              v-model="kategoriFilter"
              :options="kategoriJenisTiketOptions"
              :reduce="val => val.value"
              class="w-100"
              multiple
              @input="val => $emit('update:kategoriFilter', val)"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <b-form-group label="Status" label-for="account-username">
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              v-model="statusFilter"
              :options="statusTiketOptions"
              :reduce="val => val.value"
              class="w-100"
              @input="val => $emit('update:statusFilter', val)"
              multiple
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BButton,
} from 'bootstrap-vue'
import Cleave from 'vue-cleave-component'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
    BFormGroup,
    // BFormInput,
    // flatPickr,
    // BFormCheckbox,
    // BButton,
    // Cleave,
  },
  props: {
    tahunOptions: {
      type: Array,
      required: true,
    },
    bulanOptions: {
      type: Array,
      required: true,
    },
    kanwilOptions: {
      type: Array,
      required: true,
    },
    kategoriJenisTiketOptions: {
      type: Array,
      required: true,
    },
    statusTiketOptions: {
      type: Array,
      required: true,
    },
    tahunFilter: null,
    bulanFilter: null,
    kanwilFilter: null,
    kategoriFilter: null,
    statusFilter: null,
    /*
    searchFilter: {
      nama: '',
      private: [
        {
          id: 0,
          label: 'Publik',
        },
        {
          id: 1,
          label: 'Privat',
        },
      ],
    },
    */
  },
  data() {
    return {
      options: {
        number: {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand',
        },
      },
      statusOption: [
        {
          id: 0,
          label: 'Publik',
        },
        {
          id: 1,
          label: 'Privat',
        },
      ],
    }
  },
  mounted() {
    // const d = new Date()
    // const tanggalAwal = d.setMonth(d.getMonth() - 6)
    // this.searchFilter.tanggal_mulai = tanggalAwal
    // const dn = new Date()
    // const tanggalAkhir = dn.setMonth(dn.getMonth() + 3)
    // this.searchFilter.tanggal_akhir = tanggalAkhir
  },
  methods: {
    cariData(val) {
      // this.$emit('emitFilter', this.searchFilter)
      // this.$emit('emitFilter', val)
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
